export const processDependents = (benefits: any[]) => {
	const trueCountTemp: any = {};
	const dependentsTemp: any = {};

	benefits.forEach((benefit: any) => {
		// console.log("Plan Insured SSN:", benefit.enrollments);
		(benefit.enrollments || []).forEach((enrollment: any) => {
			const base_plan_name = enrollment.base_plan_name;
			const plan_code = enrollment.plan_code + enrollment.effective_date;
			// // console.log("Enrollment Particular---> 2", enrollment);
			if (!(plan_code in trueCountTemp)) {
				trueCountTemp[plan_code] = 0;
			}

			if (!(plan_code in dependentsTemp)) {
				dependentsTemp[plan_code] = [];
			}
			if (
				enrollment.insured_SSN !== enrollment.member_SSN &&
				enrollment.base_plan_name === enrollment.plan_name
			) {
				trueCountTemp[plan_code] += 1;
				// console.log("Enrollment Particular--->", enrollment);
				// console.log("trueCountTemp------>", trueCountTemp);
				dependentsTemp[plan_code].push(enrollment);
				// console.log("dependentsTemp", dependentsTemp);
			}
		});
	});

	return { trueCountTemp, dependentsTemp };
};

export const processDependentsForVEB = (benefits: any[]) => {
	const trueCountTemp: any = {};
	const dependentsTemp: any = {};

	benefits.forEach((benefit: any) => {
		// console.log("Plan Insured SSN:", benefit.enrollments);
		(benefit.enrollments || []).forEach((enrollment: any) => {
			const base_plan_name = enrollment.base_plan_name;
			const plan_code = enrollment.plan_code;
			// // console.log("Enrollment Particular---> 2", enrollment);
			if (!(plan_code in trueCountTemp)) {
				trueCountTemp[plan_code] = 0;
			}

			if (!(plan_code in dependentsTemp)) {
				dependentsTemp[plan_code] = [];
			}
			if (
				enrollment.insured_SSN !== enrollment.member_SSN &&
				enrollment.base_plan_name === enrollment.plan_name
			) {
				trueCountTemp[plan_code] += 1;
				// console.log("Enrollment Particular--->", enrollment);
				// console.log("trueCountTemp------>", trueCountTemp);
				dependentsTemp[plan_code].push(enrollment);
				// console.log("dependentsTemp", dependentsTemp);
			}
		});
	});

	return { trueCountTemp, dependentsTemp };
};
// let coreTrueCountTemp = 0;
// const coreDependentsTemp: any[] = [];
// (benefitsResponse.core || []).forEach((benefit: any) => {
// 	// console.log("Core Plan Insured SSN:", benefit.insured_SSN);
// 	(benefit.enrollments || []).forEach((enrollment: any) => {
// 		if (enrollment.insured_SSN !== enrollment.member_SSN) {
// 			coreTrueCountTemp++;
// 			// console.log("Enrollmwnt Core Particular--->", enrollment);
// 			coreDependentsTemp.push(enrollment);
// 		}
// 	});
// });
// let vebTrueCountTemp = 0;
// const vebDependentsTemp: any[] = [];
// (benefitsResponse.veb || []).forEach((benefit: any) => {
// 	// console.log("VEB Plan Insured SSN:", benefit.insured_SSN);

// 	(benefit.enrollments || []).forEach((enrollment: any) => {
// 		if (enrollment.insured_SSN !== enrollment.member_SSN) {
// 			vebTrueCountTemp++;
// 			// console.log("Enrollmwnt VEB Particular--->", enrollment);
// 			vebDependentsTemp.push(enrollment);
// 		}
// 		if (enrollment.base_plan_name !== enrollment.plan_name) {
// 			// console.log("Rider--->Check------->True");
// 		} else {
// 			// console.log("No rider---------found");
// 		}
// 	});
// });
